
/**
 * @abstract
 */
export abstract class AbstractTreeSelection {
/**
 * @param {?} parent
 */
constructor(public parent: AbstractTreeSelection) {}
/**
 * @abstract
 * @return {?}
 */
children() {}
/**
 * @abstract
 * @return {?}
 */
selectedChanged() {}
/**
 * @abstract
 * @return {?}
 */
indeterminateChanged() {}
private _selected: boolean = false;
private _indeterminate: boolean = false;
/**
 * @return {?}
 */
public get selected(): boolean {
        return this._selected;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set selected(value: boolean) {
        this._selected = value;
        this.indeterminate = false;
        this.children.forEach(child => child.parentChanged(value));
        if (this.parent) {
            this.parent.childChanged();
        }
        this.selectedChanged();
    }
/**
 * @return {?}
 */
public get indeterminate(): boolean {
        return this._indeterminate;
    }
/**
 * @param {?} value
 * @return {?}
 */
public set indeterminate(value: boolean) {
        value = !!value;
        if (this._indeterminate !== value) {
            this._indeterminate = value;
            this.indeterminateChanged();
        }
    }
/**
 * @return {?}
 */
childChanged(): void {
        let /** @type {?} */ oneSelectedChild = false;
        const /** @type {?} */ previousSelectedValue: boolean = this._selected;
        const /** @type {?} */ previousIndeterminateValue: boolean = this._indeterminate;
        this._selected = true;
        this._indeterminate = false;

        for (const /** @type {?} */ child of this.children) {
            if (child.indeterminate) {
                this._selected = false;
                this._indeterminate = true;
                break;
            }
            if (child.selected) {
                oneSelectedChild = true;
                if (this._selected === false) {
                    this._indeterminate = true;
                    break;
                }
            } else {
                this._selected = false;
                if (oneSelectedChild) {
                    this._indeterminate = true;
                    break;
                }
            }
        }

        if (this.parent &&
            (this._selected !== previousSelectedValue || this._indeterminate !== previousIndeterminateValue)) {
            this.parent.childChanged();
        }

        if (this.selected !== previousSelectedValue) {
            this.selectedChanged();
        }

        if (this.indeterminate !== previousIndeterminateValue) {
            this.indeterminateChanged();
        }
    }
/**
 * @param {?} selected
 * @return {?}
 */
parentChanged(selected: boolean) {
        if (selected && !this.selected) {
            this._selected = true;
            this.indeterminate = false;
            this.children.forEach(child => child.parentChanged(true));
            this.selectedChanged();
        }
        if (!selected && (this.selected || this.indeterminate)) {
            this._selected = false;
            this.indeterminate = false;
            this.children.forEach(child => child.parentChanged(false));
            this.selectedChanged();
        }
    }
}

function AbstractTreeSelection_tsickle_Closure_declarations() {
/** @type {?} */
AbstractTreeSelection.prototype._selected;
/** @type {?} */
AbstractTreeSelection.prototype._indeterminate;
/** @type {?} */
AbstractTreeSelection.prototype.parent;
}

